import React from 'react'
import WebContainer from '../WebContainer/Index'
import Title from '../Title/Index'
import DoubleQuote from '../../images/Vectors/DoubleQuote'

const Quote = ({Data}) => {
  return (
   <WebContainer _parentClass={'mdMessage'} sectionID={'message'}>
          <div className='col-12 float-start position-relative QuoteTitle text-center'>
          <Title secondHeading={Data.title} _class={'mb-3'}/>
          <p dangerouslySetInnerHTML={{ __html: Data.descp }} 
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine"/>
          <div className='doubleQuote'><DoubleQuote /></div>
         
          </div>
   </WebContainer>
  )
}

export default Quote